const DefaultData = {
    APISERVERURL: 'https://zotraiapi.azurewebsites.net/api/',
    APILOCALURL: 'http://localhost:5126/api/',
    APIACTIVEURL: 'https://zotraiapi.azurewebsites.net/api/',
    TENANTID:'babaair',
    DEFAULTCOMPANYID: '297eb922-671c-467e-a2d7-34e508d4c572',
    DEFAULTBRANCHID: '876a04f8-f777-42c7-91f5-f83353855539',
    DEFAULTCURRENCY: 'INR',
    DEFAULTPAYMENTGATEWAYFEE: 2.1,
    WEBSITE:'https://babaair.com',
    DEFAULTCOMPANYEMAIL: 'support@babaair.com',
    DEFAULTCOMPANYPHONENUMBER: '+919177656344',
    DEFAULTCOMPANYWHATSAPPNUMBER: '+919849787154 | +97334451249',
    DEFAULTCOMPANYGST: '36ANVPM2246A1Z0',
    DEFAULTCOMPANYNAME: 'BABA TRAVEL & TOURISM',
    DEFAULTBRANDNAME: 'BABA AIR',
    DEFAULTCOMPANYADDRESS:'HYDERABAD, TELANGANA',
    FACEBOOKURL:'https://www.facebook.com/babaair',
    TWITTERURL:'https://x.com/babaair',
    INSTGRAMURL:'https://www.instagram.com/babaair',
    WHATSAPPURL:'https://www.whatsapp.com/channel/0029VbBku318PgsBfirWxV3G',
    THEMECOLOR1:"#2D93D3",
    THEMECOLOR2:"#1a1a1a",
    THEMECOLOR3:"#ffffff",
    THEMECOLOR4:"#000000",
    LANDINGPAGETITLE:"Empowering the Future of Travel Booking",
    LANDINGPAGESUBTITLE:"One stop solution for your travel business",
    B2BWEBSITE:"https://b2b.babaair.com/",
    FOOTERCOPYRIGHTS:"2010 - 2025 BABA TRAVEL & TOURISM.",
    FOOTERSUBTITLE:"We make your dream more beautiful & enjoyable with lots of happiness.",
    COMPANYTYPE: "AGENT",
    USERTYPE: "AGENT",
    PLANTYPE:"CUSTOM"
};

export default DefaultData;